// extracted by css-extract-rspack-plugin
export default {"listRow":"lS77cimPMysrw0tR"};